<ps-ui-table
  [data]="surveys"
  [trackBy]="'surveyId'"
  [border]="border"
  [state]="state"
  [config]="(config$ | async) ?? initialConfig"
  (scrolled)="onScrolled()"
  (stateChange)="onTableStateChange($event)"
  [resetScroll]="resetScroll"
  *ngIf="tab$ | async as tab"
  [ngClass]="{
    'no-survey': !surveys.length,
    'dashboard-table': surveys.length
  }"
>
  <ng-container psUiTableExpandableRow>
    <ng-container
      psUiTableCheckboxColumn
      [showSelectAll]="true"
      [show]="preferences.enableBulkEditAndSorting"
      [selectBy]="'surveyId'"
      [disable]="selection"
      [selectedKeys]="selectedKeys"
      (selectedKeysChange)="onSurveysSelected($event)"
    ></ng-container>
    <ng-container
      *ngFor="let header of preferences.columns"
      [ngSwitch]="header.key"
    >
      <ng-container
        psUiTableColumn
        [title]="header.column"
        [width]="'fit'"
        [field]="'status'"
        [showClearStateButton]="true"
        [preventCheckbox]="preventCheckbox"
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.STATUS"
      >
        <ng-container
          [show]="preferences.enableBulkEditAndSorting"
          psUiTableColumnFilter
          [show]="tab.status === 'all'"
        >
          <option
            *ngFor="let status of surveyStatus"
            psUiTableColumnOption
            [value]="status.value"
          >
            {{ status.name }}
          </option>
        </ng-container>

        <ng-template psUiTableCellTemplate let-survey>
          <div class="serveryStatus">
            <button
              class="menu-btn"
              [psUiDropdownToggleFor]="surveysStatus"
              [disabled]="checkDisableSurveyStatus(survey)"
              [ngClass]="{
                greyOutInvoiceButton: checkDisableSurveyStatus(survey)
              }"
            >
              {{
                survey.status
                  | surveyStatusText
                    : survey.schedule_launch
                    : survey.schedule_pause
                    : survey.auto_launch
              }}
            </button>
            <ps-ui-dropdown
              class="status-dropdown"
              #surveysStatus="psUiDropdown"
            >
              <div *ngFor="let statusButton of statusButtons">
                <button
                  psUiDropdownItem
                  *ngIf="statusButton.condition.indexOf(survey.status) > -1"
                  (click)="onChangeStatus(statusButton.value, survey)"
                >
                  {{ statusButton.value }}
                </button>
              </div>
            </ps-ui-dropdown>
          </div>
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.CRM_ID">
        <ng-container *ngIf="canSeeCrmId()">
          <ng-container
            psUiTableColumn
            [title]="header.column"
            [field]="header.key"
            [searchable]="preferences.enableBulkEditAndSorting"
            [showClearStateButton]="true"
            [preventCheckbox]="preventCheckbox"
            [readOnlySearch]="readOnlyFlags.crm"
          >
            <ng-container
              psUiTableColumnFilter
              [show]="preferences.enableBulkEditAndSorting"
              [delegate]="filter"
            >
              <option psUiTableColumnOption value="EMPTY">Empty</option>
              <option psUiTableColumnOption value="NOT EMPTY">Not Empty</option>
            </ng-container>
            <ng-template
              psUiTableCellTemplate
              (tap)="onTableCellClicked($event)"
              let-survey
            >
              <div class="sernewTitle">
                <a class="survey-link" [routerLink]="survey | surveyRouterLink">
                  {{ survey[header.key] }}</a
                >
              </div>
            </ng-template>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.OPERATOR_PROJECT_MANAGER"
      >
        <ng-container *ngIf="canSeeOperatorProjectManager()">
          <ng-container
            psUiTableColumn
            [title]="header.column"
            [field]="header.key"
            [searchable]="preferences.enableBulkEditAndSorting"
            [showClearStateButton]="true"
            [preventCheckbox]="preventCheckbox"
            [readOnlySearch]="readOnlyFlags.pm"
          >
            <ng-container
              psUiTableColumnFilter
              [show]="preferences.enableBulkEditAndSorting"
              [delegate]="filter"
            >
              <option psUiTableColumnOption value="EMPTY">Empty</option>
              <option psUiTableColumnOption value="NOT EMPTY">Not Empty</option>
            </ng-container>
            <ng-template
              psUiTableCellTemplate
              (tap)="onTableCellClicked($event)"
              let-survey
            >
              <div class="sernewTitle">
                <a class="survey-link" [routerLink]="survey | surveyRouterLink">
                  {{ survey[header.key] || '_' }}</a
                >
              </div>
            </ng-template>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container
        psUiTableColumn
        [title]="header.column"
        [field]="header.key"
        [searchable]="preferences.enableBulkEditAndSorting"
        [showClearStateButton]="true"
        [preventCheckbox]="preventCheckbox"
        [readOnlySearch]="readOnlyFlags.bpm"
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.BUYER_PROJECT_MANAGER"
      >
        <ng-container
          psUiTableColumnFilter
          [show]="preferences.enableBulkEditAndSorting"
          [delegate]="filter"
        >
          <option psUiTableColumnOption value="EMPTY">Empty</option>
          <option psUiTableColumnOption value="NOT EMPTY">Not Empty</option>
        </ng-container>
        <ng-template
          psUiTableCellTemplate
          (tap)="onTableCellClicked($event)"
          let-survey
        >
          <div class="sernewTitle">
            <a class="survey-link" [routerLink]="survey | surveyRouterLink">
              {{ survey[header.key] || '_' }}</a
            >
          </div>
        </ng-template>
      </ng-container>

      <ng-container
        psUiTableColumn
        [width]="'fit'"
        [title]="header.column"
        [field]="header.key"
        [sortable]="preferences.enableBulkEditAndSorting"
        [searchable]="preferences.enableBulkEditAndSorting"
        [searchType]="'contains'"
        [showClearStateButton]="true"
        [preventCheckbox]="preventCheckbox"
        [readOnlySearch]="readOnlyFlags.surveyTitle"
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.SURVEY_TITLE"
      >
        <ng-template
          psUiTableCellTemplate
          (tap)="onTableCellClicked($event)"
          let-survey
        >
          <a
            class="survey-link"
            title="{{ survey.surveyTitle }}"
            [routerLink]="survey | surveyRouterLink"
          >
            {{ survey.surveyTitle | truncateWord : 50 }}
          </a>
          <ps-ui-aida-enabled-tooltip
            [isAidaEnabled]="survey.is_aida_enabled"
            class="ms-1"
          ></ps-ui-aida-enabled-tooltip>
        </ng-template>
      </ng-container>

      <ng-container
        psUiTableColumn
        [width]="'fit'"
        [title]="header.column"
        [field]="header.key"
        [showClearStateButton]="true"
        [preventCheckbox]="preventCheckbox"
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.PACING"
      >
        <ng-template psUiTableCellTemplate (tap)="changeBar()" let-survey>
          <ng-container *ngIf="survey.paceData?.pace.length">
            <ps-ui-custom-tooltip
              [direction]="'right'"
              [showArrow]="false"
              class="tooltip-pacing-{{ survey.surveyId }}"
            >
              <div
                psUiTooltipTarget
                (mouseenter)="onHoverPacing(survey.surveyId)"
                (mouseleave)="onHoverPacing(null)"
              >
                <ps-ui-linear-gauge-chart
                  [completes]="survey.fielded"
                  [expected]="survey.paceData?.cumulative_pace.expected"
                  [goal]="survey.goal"
                >
                </ps-ui-linear-gauge-chart>
              </div>
              <ps-ui-aida-chart-tooltip
                psUiTooltipContent
                defaultClass="tooltip-content"
                class="tooltip-style ng-tooltip-arrow"
                [ngClass]="{
                  'ng-tooltip-left': isPacingTooltipLeft,
                  'ng-tooltip-right': !isPacingTooltipLeft
                }"
              ></ps-ui-aida-chart-tooltip>
            </ps-ui-custom-tooltip>
          </ng-container>
          <!-- <ps-ui-bar-chart
            *ngIf="survey.lineChartActive"
            [elementId]="survey.surveyId.toString() + 'bar'"
            [dataSets]="survey.showDay"
            [stacked]="false"
            (getHour)="getHour($event, survey)"
          ></ps-ui-bar-chart>
          <ps-ui-line-chart
            *ngIf="!survey.lineChartActive"
            [elementId]="survey.surveyId.toString() + 'line'"
            [dataSets]="survey.paceData.pace"
            (getDay)="getDay($event, survey)"
          ></ps-ui-line-chart> -->
        </ng-template>
      </ng-container>

      <ng-container
        psUiTableColumn
        [title]="header.column"
        [field]="header.key"
        [searchable]="isCompanySelectionAllowed"
        [searchDropdownItems]="isCompanySelectionAllowed"
        [showClearStateButton]="true"
        [multi]="false"
        [sortable]="true"
        [showClearStateButton]="true"
        [preventCheckbox]="preventCheckbox"
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.BUYER_ACCOUNT"
      >
        <ng-container psUiTableColumnFilter [show]="isCompanySelectionAllowed">
          <option
            *ngFor="let company of companies$ | async"
            psUiTableColumnOption
            [value]="company.name"
          >
            {{ company.name }}
          </option>
        </ng-container>
        <ng-template
          psUiTableCellTemplate
          (tap)="onTableCellClicked($event)"
          let-survey
        >
          <div class="buyerv">
            <a
              class="survey-link buyerv"
              [routerLink]="survey | surveyRouterLink"
              >{{ survey.buyerAccount }}</a
            >
          </div>
        </ng-template>
      </ng-container>

      <ng-container
        psUiTableColumn
        [title]="header.column"
        [field]="header.key"
        [sortable]="preferences.enableBulkEditAndSorting"
        [showClearStateButton]="true"
        [preventCheckbox]="preventCheckbox"
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.FIELDED"
      >
        <ng-template
          psUiTableCellTemplate
          (tap)="onTableCellClicked($event)"
          let-survey
        >
          <a class="survey-link" [routerLink]="survey | surveyRouterLink"
            >{{ survey.fielded | number }} | {{ survey.goal | number }}</a
          >
        </ng-template>
      </ng-container>

      <ng-container
        psUiTableColumn
        [title]="header.column"
        [field]="header.key"
        [sortable]="preferences.enableBulkEditAndSorting"
        [showClearStateButton]="true"
        [preventCheckbox]="preventCheckbox"
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.AVERAGE_CPI"
      >
        <ng-template
          psUiTableCellTemplate
          (tap)="onTableCellClicked($event)"
          let-survey
        >
          <a
            attr.e2e-data="quota-id-{{ survey.surveyId }}"
            class="survey-link"
            [routerLink]="survey | surveyRouterLink"
            >{{
              survey.averageCpi !== 'NA'
                ? (survey.averageCpi
                  | currency : (!supplier ? survey.currencySymbol : '$'))
                : 'NA'
            }}</a
          >
        </ng-template>
      </ng-container>

      <ng-container
        psUiTableColumn
        [title]="header.column"
        [showClearStateButton]="true"
        [preventCheckbox]="preventCheckbox"
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.EPC"
      >
        <ng-template
          psUiTableCellTemplate
          (tap)="onTableCellClicked($event)"
          let-survey
        >
          <a class="survey-link" [routerLink]="survey | surveyRouterLink">{{
            survey.epc !== undefined
              ? (survey.epc | currency : survey.currencySymbol)
              : 'NA'
          }}</a>
        </ng-template>
      </ng-container>

      <ng-container
        psUiTableColumn
        [title]="header.column"
        [field]="header.key"
        [sortable]="preferences.enableBulkEditAndSorting"
        [preventCheckbox]="preventCheckbox"
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.PROJECT_COST"
      >
        <ng-template
          psUiTableCellTemplate
          (tap)="onTableCellClicked($event)"
          let-survey
        >
          <a class="survey-link" [routerLink]="survey | surveyRouterLink">{{
            survey.current_cost | currency : survey.currencySymbol
          }}</a>
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.MARGIN">
        <ng-container *ngIf="canSeeMarginAndBank()">
          <ng-container
            psUiTableColumn
            [title]="header.column"
            [showClearStateButton]="true"
            [preventCheckbox]="preventCheckbox"
          >
            <ng-template
              psUiTableCellTemplate
              (tap)="onTableCellClicked($event)"
              let-survey
            >
              <a class="survey-link" [routerLink]="survey | surveyRouterLink"
                >${{ survey[header.key] }}</a
              >
            </ng-template>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.BANK">
        <ng-container *ngIf="!isMultiBuyer">
          <ng-container
            psUiTableColumn
            [title]="header.column"
            [showClearStateButton]="true"
            [preventCheckbox]="preventCheckbox"
          >
            <ng-template
              psUiTableCellTemplate
              (tap)="onTableCellClicked($event)"
              let-survey
            >
              <a class="survey-link" [routerLink]="survey | surveyRouterLink"
                >${{ survey[header.key] }}</a
              >
            </ng-template>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container
        psUiTableColumn
        [title]="header.column"
        [field]="header.key"
        [sortable]="preferences.enableBulkEditAndSorting"
        [showClearStateButton]="true"
        [preventCheckbox]="preventCheckbox"
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.COUNTRY_CODE"
      >
        <ng-container
          [show]="preferences.enableBulkEditAndSorting"
          psUiTableColumnFilter
        >
          <option
            *ngFor="let country of countries"
            psUiTableColumnOption
            [value]="country.short_Code"
          >
            {{ country.name }}
          </option>
        </ng-container>
        <ng-template
          psUiTableCellTemplate
          (tap)="onTableCellClicked($event)"
          let-survey
        >
          <ps-country-cell-view [countries]="countries" [survey]="survey">
            <ng-template psCountryViewableCellContent let-locale>
              <a
                class="survey-link"
                [routerLink]="survey | surveyRouterLink"
                *ngIf="
                  !survey?.mc?.SVP ||
                  !survey?.mc?.parent ||
                  survey?.tracker?.enable
                "
              >
                {{ locale.country_code }}
              </a>
            </ng-template>

            <ng-template
              psCountryHoverableCellContent
              let-locales
              let-hovered="hovered"
            >
              <ps-ui-custom-tooltip [directionY]="'bottom'" [showArrow]="false">
                <div
                  psUiTooltipTarget
                  class="multiple-label-container d-flex justify-content-center"
                >
                  <div class="mcqb-survey-count pb-0 rounded-2">
                    {{ locales.length }}
                  </div>
                  <div class="multiple-label">Multiple</div>
                </div>

                <div
                  psUiTooltipContent
                  defaultClass="tooltip-content"
                  class="bg-white text-dark border rounded p-0 hoverable-country-cell-content"
                  [ngClass]="{ 'freezed-tooltip-content': hovered }"
                  attr.data-e2e="multiple-mcqb-{{ survey.surveyId }}"
                >
                  <div
                    class="d-flex justify-content-between"
                    *ngFor="let locale of locales"
                  >
                    <div class="d-flex justify-content-between">
                      <div class="mx-1 px-0 py-2 country-name-column">
                        <span
                          attr.data-e2e="language-code-{{
                            locale.country_code
                          }}-{{ locale.language_short_code }}"
                        >
                          {{ locale.country_name }}
                        </span>
                      </div>
                    </div>

                    <div class="mx-1 px-0 py-2">
                      <div class="d-flex justify-content-between">
                        <span
                          class="p-1 fw-bold language-icon"
                          attr.data-e2e="language-code-{{
                            locale.country_code
                          }}-{{ locale.language_short_code }}"
                        >
                          {{ locale.language_short_code | uppercase }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </ps-ui-custom-tooltip>
            </ng-template>
          </ps-country-cell-view>
        </ng-template>
      </ng-container>

      <ng-container
        psUiTableColumn
        [title]="header.column"
        [field]="header.key"
        [sortable]="preferences.enableBulkEditAndSorting"
        [showClearStateButton]="true"
        [preventCheckbox]="preventCheckbox"
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.LAUNCH_DATE"
      >
        <ng-template
          psUiTableCellTemplate
          (tap)="onTableCellClicked($event)"
          let-survey
        >
          <a
            [ngClass]="{
              'survey-link': survey.survey_launch_date,
              'blank-date': !survey.survey_launch_date
            }"
            [routerLink]="survey | surveyRouterLink"
          >
            {{
              survey.survey_launch_date
                ? (survey.survey_launch_date | date : 'yyyy/MM/dd HH:mm')
                : '-'
            }}
          </a>
        </ng-template>
      </ng-container>

      <ng-container
        psUiTableColumn
        [title]="header.column"
        [sortable]="preferences.enableBulkEditAndSorting"
        [sortDelegate]="sort"
        [field]="'reconciliation'"
        [showClearStateButton]="true"
        [preventCheckbox]="preventCheckbox"
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.RECONCILED"
      >
        <ng-container
          [show]="preferences.enableBulkEditAndSorting"
          psUiTableColumnFilter
          [delegate]="filter"
        >
          <option psUiTableColumnOption [value]="RECONCILIATION.TYPES.ACCEPT">
            Accept
          </option>
          <option psUiTableColumnOption [value]="RECONCILIATION.TYPES.REJECT">
            Reject
          </option>
          <option psUiTableColumnOption [value]="RECONCILIATION.TYPES.COMPLETE">
            Complete
          </option>
          <option
            psUiTableColumnOption
            [value]="RECONCILIATION.TYPES.NOT_RECONCILED"
          >
            Not Reconciled
          </option>
        </ng-container>
        <ng-template
          psUiTableCellTemplate
          (tap)="onTableCellClicked($event)"
          let-survey
        >
          <a class="survey-link" [routerLink]="survey | surveyRouterLink">{{
            survey[RECONCILIATION.KEY] | reconciliationStatus
          }}</a>
        </ng-template>
      </ng-container>

      <ng-container
        psUiTableColumn
        [title]="header.column"
        [field]="header.key"
        [sortable]="preferences.enableBulkEditAndSorting"
        [showClearStateButton]="true"
        [preventCheckbox]="preventCheckbox"
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.SURVEY_ID"
      >
        <ng-template
          psUiTableCellTemplate
          (tap)="onTableCellClicked($event)"
          let-survey
        >
          <a
            attr.e2e-data="table-survey-id-{{ survey?.surveyId }}"
            class="survey-link table-survey-id"
            [routerLink]="survey | surveyRouterLink"
            >{{ survey[header.key] }}</a
          >
        </ng-template>
      </ng-container>

      <ng-container
        psUiTableColumn
        [title]="header.column"
        [field]="header.key"
        [sortable]="preferences.enableBulkEditAndSorting"
        [showClearStateButton]="true"
        [preventCheckbox]="preventCheckbox"
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.IN_PROGRESS"
      >
        <ng-template
          psUiTableCellTemplate
          (tap)="onTableCellClicked($event)"
          let-survey
        >
          <a class="survey-link" [routerLink]="survey | surveyRouterLink">{{
            survey[header.key]
          }}</a>
        </ng-template>
      </ng-container>

      <ng-container
        psUiTableColumn
        [title]="header.column"
        [field]="header.key"
        [sortable]="preferences.enableBulkEditAndSorting"
        [showClearStateButton]="true"
        [preventCheckbox]="preventCheckbox"
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.CURRENT_IR"
      >
        <ng-template
          psUiTableCellTemplate
          (tap)="onTableCellClicked($event)"
          let-survey
        >
          <ng-container
            *ngIf="
              survey.status !== SURVEY_STATUS.Draft &&
                survey.currentIR as currentIR;
              else noIR
            "
          >
            <a class="survey-link" [routerLink]="survey | surveyRouterLink">
              {{ currentIR }}<span aria-hidden="true">%</span>
            </a>
          </ng-container>

          <ng-template #noIR>
            <span>NA</span>
          </ng-template>
        </ng-template>
      </ng-container>

      <ng-container
        psUiTableColumn
        [title]="header.column"
        [field]="header.key"
        [sortable]="preferences.enableBulkEditAndSorting"
        [showClearStateButton]="true"
        [preventCheckbox]="preventCheckbox"
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.LOI"
      >
        <ng-template
          psUiTableCellTemplate
          (tap)="onTableCellClicked($event)"
          let-survey
        >
          <a class="survey-link" [routerLink]="survey | surveyRouterLink">{{
            survey[header.key]
          }}</a>
        </ng-template>
      </ng-container>

      <ng-container
        psUiTableColumn
        [title]="header.column"
        [field]="header.key"
        [showClearStateButton]="true"
        [preventCheckbox]="preventCheckbox"
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.HEALTH_CHECK"
      >
        <ng-container
          [show]="preferences.enableBulkEditAndSorting"
          psUiTableColumnFilter
          [delegate]="filter"
        >
          <option psUiTableColumnOption group="Filter by Alerts" value="RED">
            Red
          </option>
          <option psUiTableColumnOption value="YELLOW">Yellow</option>
          <option psUiTableColumnOption value="GREEN">Green</option>
          <option psUiTableColumnOption value="GREY">Grey</option>
          <option psUiTableColumnOption value="NOT AVAILABLE">
            Not Available
          </option>

          <option
            psUiTableColumnOption
            group="Filter by Metrics"
            value="Buyer Drop Rate"
          >
            Buyer Drop Rate
          </option>
          <option psUiTableColumnOption value="Buyer Over Quota">
            Buyer Over Quota
          </option>
          <option psUiTableColumnOption value="Completes Per Hour">
            Completes Per Hour
          </option>
          <option psUiTableColumnOption value="Pace">Pace</option>
          <option psUiTableColumnOption value="IR Delta">IR Delta</option>
          <option psUiTableColumnOption value="LOI Delta">LOI Delta</option>
          <option psUiTableColumnOption value="PS Status Ratio">
            PS Status Ratio
          </option>
          <option psUiTableColumnOption value="Supplier Dominance">
            Supplier Dominance
          </option>
          <option psUiTableColumnOption value="Too Good to be True">
            Too Good to be True
          </option>
        </ng-container>

        <ng-template psUiTableCellTemplate let-survey>
          <ps-health-check-widget
            [survey]="survey"
            [countries]="countries"
            [boundaries]="
              table?.container?.nativeElement?.getBoundingClientRect()
            "
          ></ps-health-check-widget>
        </ng-template>
      </ng-container>

      <ng-container
        psUiTableColumn
        [title]="header.column"
        [field]="header.key"
        [searchable]="preferences.enableBulkEditAndSorting"
        [showClearStateButton]="true"
        [preventCheckbox]="preventCheckbox"
        [readOnlySearch]="readOnlyFlags.billing"
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.BILLING_NUMBER"
      >
        <ng-container
          [show]="preferences.enableBulkEditAndSorting"
          psUiTableColumnFilter
          [delegate]="filter"
        >
          <option psUiTableColumnOption value="EMPTY">Empty</option>
          <option psUiTableColumnOption value="NOT EMPTY">Not Empty</option>
        </ng-container>
        <ng-template
          psUiTableCellTemplate
          (tap)="onTableCellClicked($event)"
          let-survey
        >
          <div class="sernewTitle">
            <a class="survey-link" [routerLink]="survey | surveyRouterLink">
              {{ survey[header.key] | truncateWord : 16 }}</a
            >
          </div>
        </ng-template>
      </ng-container>

      <ng-container
        psUiTableColumn
        [title]="header.column"
        [field]="header.key"
        [searchable]="preferences.enableBulkEditAndSorting"
        [sortable]="preferences.enableBulkEditAndSorting"
        [searchType]="'contains'"
        [showClearStateButton]="true"
        [preventCheckbox]="preventCheckbox"
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.TEMPLATE"
      >
        <ng-template
          *ngIf="preferences.enableBulkEditAndSorting"
          psUiTableColumnCustomHeader
        >
          <ps-ui-tree-dropdown
            class="template-dropdown"
            [labelNone]="'Template'"
            labelAlignment="start"
            [dropdownItems]="(templates$ | async) || []"
            [folderOption]="templateFolderOption"
            [fileOption]="templateOption"
            (selectedFiles)="onSelectedTemplates($event)"
            [multi]="true"
            [showFooterSelectButton]="true"
            [showFolderArrowIcon]="true"
            [addNewFolder]="true"
            [isFirstFooterButton]="false"
            [footerSelectButtonText]="'Confirm'"
            [indicator]="true"
            [showClearStateButton]="true"
          >
            <ng-template psUiSelectDropdownIcon>
              <i class="fa fa-sort template-icon" aria-hidden="true"></i>
            </ng-template>
          </ps-ui-tree-dropdown>
        </ng-template>
        <ng-template
          psUiTableCellTemplate
          (tap)="onTableCellClicked($event)"
          let-survey
        >
          <div class="sernewTitle">
            <a class="survey-link" [routerLink]="survey | surveyRouterLink"
              >{{ survey[header.key] | truncateWord : 10 }}
            </a>
          </div>
        </ng-template>
      </ng-container>

      <ng-container
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.TRAFFIC_CHANNELS"
      >
        <ng-container
          psUiTableColumn
          [title]="header.column"
          [preventCheckbox]="preventCheckbox"
          [showClearStateButton]="true"
          [sortable]="
            preferences.enableBulkEditAndSorting &&
            header.key === SURVEY_LISTING_TABLE_HEADERS.TRAFFIC_CHANNELS
          "
          [field]="header.key"
        >
          <ng-container
            [show]="preferences.enableBulkEditAndSorting"
            psUiTableColumnFilter
            [delegate]="filter"
          >
            <option psUiTableColumnOption value="EXIST">Exist</option>
            <option psUiTableColumnOption value="NOT EXIST">Not Exist</option>
          </ng-container>

          <ng-template psUiTableCellTemplate let-survey let-index="index">
            <div class="widget-column">
              <ps-widget-button
                *ngIf="preferences.widget(header.key).count(survey)"
                [widget]="preferences.widget(header.key)"
                [count]="preferences.widget(header.key).count(survey)"
                [survey]="survey"
                [active]="
                  selectedWidget.selected &&
                  selectedWidget.for(survey) &&
                  selectedWidget.key === header.key
                "
                (tap)="onWidgetPressed($event, survey, index)"
              ></ps-widget-button>
            </div>
          </ng-template>
        </ng-container>
      </ng-container>

      <ng-container
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.GROUPED_SURVEYS"
      >
        <ng-container
          psUiTableColumn
          [title]="header.column"
          [field]="header.key"
          [preventCheckbox]="preventCheckbox"
          [showClearStateButton]="true"
          [width]="25"
        >
          <ng-container
            [show]="preferences.enableBulkEditAndSorting"
            psUiTableColumnFilter
            [delegate]="filter"
          >
            <option psUiTableColumnOption [value]="projectTypes.MCQB">
              Multi-country Survey
            </option>
            <option psUiTableColumnOption [value]="projectTypes.TRACKER">
              Tracker Survey
            </option>
            <option psUiTableColumnOption [value]="projectTypes.GROUPED">
              Grouped Survey
            </option>
          </ng-container>
          <ng-template psUiTableCellTemplate let-survey let-index="index">
            <div class="widget-column">
              <ps-widget-button
                *ngIf="preferences.widget(header.key).count(survey)"
                [widget]="preferences.widget(header.key)"
                [count]="preferences.widget(header.key).count(survey)"
                [survey]="survey"
                [active]="
                  selectedWidget.selected &&
                  selectedWidget.for(survey) &&
                  selectedWidget.key === header.key
                "
                (tap)="onWidgetPressed($event, survey, index)"
              ></ps-widget-button>
            </div>
          </ng-template>
        </ng-container>
      </ng-container>

      <ng-container
        psUiTableColumn
        [title]="header.column"
        [field]="'scorePercentage'"
        [multi]="true"
        [sortable]="preferences.enableBulkEditAndSorting"
        [width]="25"
        [showClearStateButton]="true"
        [preventCheckbox]="preventCheckbox"
        *ngSwitchCase="SURVEY_LISTING_TABLE_HEADERS.SCORE"
      >
        <ng-container
          psUiTableColumnFilter
          [show]="preferences.enableBulkEditAndSorting"
          [delegate]="filter"
        >
          <option psUiTableColumnOption value="GREEN">Green</option>
          <option psUiTableColumnOption value="YELLOW">Yellow</option>
          <option psUiTableColumnOption value="RED">Red</option>
        </ng-container>
        <ng-template psUiTableCellTemplate let-survey>
          <div class="d-flex">
            <ps-ui-survey-score-badge
              [type]="'scorePercentage'"
              [surveyScore]="{
                score: survey.score,
                scorePercentage: survey.scorePercentage
              }"
              [mc]="survey.mc"
            ></ps-ui-survey-score-badge>
          </div>
        </ng-template>
      </ng-container>

      <ng-container
        psUiTableColumn
        [preventCheckbox]="preventCheckbox"
        [title]="header.column"
        [showClearStateButton]="true"
        *ngSwitchDefault
      >
        <ng-template
          psUiTableCellTemplate
          (tap)="onTableCellClicked($event)"
          let-survey
        >
          <a class="survey-link" [routerLink]="survey | surveyRouterLink">{{
            survey[header.key]
          }}</a>
        </ng-template>
      </ng-container>
    </ng-container>

    <ng-container
      psUiTableColumn
      [preventCheckbox]="preventCheckbox"
      title="Manage"
      [width]="'fit'"
    >
      <ng-template
        psUiTableColumnCustomHeader
        *ngIf="preferences.configs.dynamic"
      >
        <div class="gear">
          <a (click)="openDashboardPreferenceModal()">
            <i class="fa fa-2x fa-gear"></i>
          </a>
        </div>
      </ng-template>

      <ng-template
        psUiTableCellTemplate
        *psHasRole="['operator', 'buyer']"
        let-survey
      >
        <div class="dots-outer">
          <button
            class="dotsv"
            *ngIf="survey.status === SURVEY_STATUS.Draft"
            (click)="
              onDetails(survey.surveyId, survey.status, survey.samplesType)
            "
          >
            <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
          </button>
          <button
            id="Dotsv-{{ survey.surveyId }}"
            class="dotsv"
            [psUiDropdownToggleFor]="manageDropDown"
            *ngIf="survey.status !== SURVEY_STATUS.Draft && !isMasterMultiBuyer"
            [disabled]="checkUserLevelAccess()"
          >
            <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
          </button>
          <ps-ui-dropdown
            class="manage-dropdown"
            #manageDropDown="psUiDropdown"
            [canClose]="managing"
            (click)="onCloseManageMenu()"
          >
            <button
              psUiDropdownItem
              (click)="
                onDetails(survey.surveyId, survey.status, survey.samplesType)
              "
            >
              Manage
            </button>
            <button
              *ngIf="survey.samplesType !== RECONTACT_SURVEY_SAMPLE_TYPE"
              psUiDropdownItem
              (click)="onClone(survey.surveyId)"
              psUiGtagEvent
              trackOn="click"
              action="create_survey"
              category="Survey_Create"
              [params]="{ event_label: 'Clone Button Clicked' }"
              data-e2e="dasbhoard-clone-button"
              id="dasbhoard-clone-button-{{ survey.surveyId }}"
            >
              Clone
            </button>
            <button
              *ngIf="survey.project_type === projectTypes.GROUPED"
              psUiDropdownItem
              (click)="onUnGroupSurvey(survey)"
            >
              Ungroup
            </button>
            <ps-ui-dropdown
              [toggleSubmenu]="true"
              class="btn-group"
              *ngIf="
                preferences.configs.trafficChannels &&
                survey.status === SURVEY_STATUS.Live
              "
            >
              <button
                type="button"
                class="btn btn-primary dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                [disabled]="survey?.mc?.SVP"
                (click)="onOpenTrafficChannelManage()"
              >
                Traffic Channel
              </button>
              <ul class="dropdown-menu">
                <li>
                  <ps-ui-dropdown-item
                    (click)="
                      onCreateTC(
                        'REPLICA',
                        'surveyListingPage',
                        survey.surveyId
                      )
                    "
                    >Replica</ps-ui-dropdown-item
                  >
                </li>
                <li>
                  <ps-ui-dropdown-item
                    (click)="
                      onCreateTC(
                        'SPECIFIC AUDIENCE',
                        'surveyListingPage',
                        survey.surveyId
                      )
                    "
                    >Specific Audience</ps-ui-dropdown-item
                  >
                </li>
                <li>
                  <ps-ui-dropdown-item
                    (click)="
                      onCreateTC(
                        'TARGETED LIST',
                        'surveyListingPage',
                        survey.surveyId
                      )
                    "
                    >Targeted List</ps-ui-dropdown-item
                  >
                </li>
              </ul>
            </ps-ui-dropdown>

            <button
              psUiDropdownItem
              (click)="onDownloadReport(survey.surveyId)"
            >
              Download Report
            </button>
          </ps-ui-dropdown>
        </div>
        <span
          *ngIf="
            (survey.status === SURVEY_STATUS.Draft ||
              survey.status === SURVEY_STATUS.Scheduled) &&
            tab.status !== 'all'
          "
          class="del-btn"
        >
          <button (click)="onDelete(survey.surveyId, survey.status)">
            <i class="fa fa-trash" aria-hidden="true"></i>
          </button>
        </span>
      </ng-template>

      <ng-template psUiTableCellTemplate *psHasRole="'supplier'">
        <div class="dots-outer">
          <button class="dotsv">
            <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
          </button>
        </div>
      </ng-template>
    </ng-container>

    <ng-template psUiTableExpandableContent let-survey>
      <ps-widget-container
        [expanded]="true"
        [widget]="selectedWidget.widget"
        [survey]="survey"
        [isDasaboard]="isDasaboard"
        [tab]="tab"
        [isMultiCountryWidget]="isDashboardEnabled(survey)"
      ></ps-widget-container>
    </ng-template>
  </ng-container>

  <ng-template psUiTableCaption [placement]="'bottom'">
    <p>
      Showing 1 to {{ length }}
      <!-- of {{ tab.count }} entries -->
    </p>
  </ng-template>
</ps-ui-table>
